import React, { useContext } from "react";
import { CameraSection } from "../../context/CameraContext";
import { FiMoreVertical, FiArrowLeft, FiPlus, FiCamera } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const CameraList = () => {
  const { t } = useTranslation();
  const { CameraShowHideFunc } = useContext(CameraSection);

  // نمونه دیتا - در واقعیت از API میاد
  const cameras = [
    // { id: 1, name: t("اتاق کار"), location: t("طبقه اول") },
    // { id: 2, name: t("اتاق نشیمن"), location: t("طبقه همکف") },
    // { id: 3, name: t("حیاط"), location: t("فضای باز") },
  ];

  return (
    <div>
      {/* Camera List */}
      <div className="cameras-list">
        {cameras.map((camera, index) => (
          <div key={index} className="camera-list-item">
            <div className="camera-list-info">
              <div className="camera-list-icon">
                <FiCamera size={18} />
              </div>
              <div>
                <p className="camera-list-name">{camera.name}</p>
                <p className="camera-list-location">{camera.location}</p>
              </div>
            </div>
            <FiMoreVertical className="camera-list-menu" />
          </div>
        ))}
      </div>

      {/* Add Camera Button */}
      <button
        className="add-camera-btn"
        onClick={() => CameraShowHideFunc("addCamera")}
      >
        <FiPlus size={18} />
        <span>{t("افزودن دوربین")}</span>
      </button>

      {/* Back Button */}
      {/* <button
        className="camera-back-btn"
        onClick={() => CameraShowHideFunc("firstPage")}
      >
        <FiArrowLeft size={18} />
        <span>{t("بازگشت")}</span>
      </button> */}
    </div>
  );
};

export { CameraList };